//login session
export const LOGIN_HOME = '/sign-in';
export const SIGN_IN_ROUTE = '/sign-in';
export const FORGET_ROUTE = '/forget-password';
export const FORGET_ROUTE_SETTINGS = '/forgot-password';
export const SIGNUP_ROUTE = '/register';
export const TERMS_CONDITION_ROUTE = '/terms-condition';
export const RESET_PASSWORD_ROUTE = '/reset-password/:token';
export const OTP_VERIFY_ROUTE = '/verify';
export const CUSTOMIZE_EXPERIENCE = '/customize-experience';
export const ON_BOARDING_ROUTE = '/onboarding';
export const CREATE_ORGANIZATION_ROUTE = '/create-organization';
export const INVITE_ROUTE = '/invite/:token';
export const GUEST_LOGIN_ROUTE = '/guest-login/';
export const GUEST_USER_REGISTER_ROUTE = '/guest-user-register/';
export const AR_VIEWER_ROUTE = '/ar-viewer/';
export const PUBLIC_AR_VIEWER_ROUTE = '/ar-viewer/:token';
export const AR_REDIRECT_ROUTE = '/ar-redirect/';
export const PUBLIC_AR_REDIRECT_ROUTE = '/ar-redirect/:token';
export const ANDROID_CEILING_AR_ROUTE = '/android-ceiling-ar/';
export const CEILING_CLIP_ROUTE = '/ceilingclip';

export const PRODUCT_AR_VIEWER_ROUTE = '/p-ar-viewer/';
export const PRODUCT_AR_VIEWER_ROUTE_PUBLIC = '/p-ar-viewer/:token';
export const PRIVATE_AR_ROUTE = '/private-ar/:productUnicode';
//export const LINK_VERIFY_ROUTE = '/verify-email-with-link/:token'
export const LINK_VERIFY_ROUTE = '/email-verify/:token';

export const TERMS_AND_CONDITION_ROUTE = '/tnc';
export const PRIVACY_POLICY_ROUTE = '/privacypolicy';
export const TERMS_OF_USE_ROUTE = '/termsofuse';
export const SLA_AGREEMENT_ROUTE = '/sla-agreement';
export const UPLOAD_3D_MODEL_HELP_ROUTE = '/3d-model-help-center';

//admin routes
export const ADMIN_HOME = '/dashboard';
export const ADMIN_HOME_PATH = '/home';
export const ADMIN_DASHBOARD = '/dashboard';
export const ADMIN_SETTINGS = '/settings';
export const ADMIN_TEAMS = '/teams';
export const SEARCH = '/s';
export const SEARCH_TEXT = '/s/:text';
export const COMMON_HOME = '/';

// user routes
export const MY_ACCOUNT_ROUTE = '/my-account';
export const ADD_CREDITS_ROUTE = '/add-credits';
export const LOGOUT_ROUTE = '/sign-in';
export const QUIT_ROUTE = '/quit';

export const MY_PRODUCTS_ROUTE = '/products';
export const MY_PROJECTS_ROUTE = '/projects';
export const PRODUCT_CONFIGURATORS_ROUTE = '/product-configurators';
export const PRODUCT_CONFIGURATORS_ROUTE_V2 = '/my-files/product-configurators';
export const PRODUCT_CONFIGURATOR_TEMPLATES_ROUTE = '/product-configurator-templates';
export const PRODUCT_CONFIGURATOR_ROUTE = '/product-configurators/:configuratorId/*';
export const ADD_PRODUCT_CONFIGURATOR_ROUTE = '/product-configurators/new/*';
export const PRODUCT_CONFIGURATOR_SCENES_ROUTE = '/product-configurators/:configuratorId/config/scenes';
export const PRODUCT_CONFIGURATOR_SCENE_ROUTE = '/product-configurators/:configuratorId/config/scenes/:sceneId';
export const PRODUCT_CONFIGURATOR_TAB_ROUTE = '/product-configurators/:configuratorId/:tabName';
export const PRODUCT_CONFIGURATOR_SCENE_PRODUCTS_ROUTE = '/product-configurators/:configuratorId/config/scenes/:sceneId/products';
export const PRODUCT_CONFIGURATOR_SCENE_PRODUCT_ADD_ROUTE = '/product-configurators/:configuratorId/config/scenes/:sceneId/products/add';
export const PRODUCT_CONFIGURATOR_SCENE_VIEW_ADD_ROUTE = '/product-configurators/:configuratorId/config/scenes/:sceneId/views/add';
export const PRODUCT_CONFIGURATOR_SCENE_VIEWS_ROUTE = '/product-configurators/:configuratorId/config/scenes/:sceneId/views';
export const PRODUCT_CONFIGURATOR_SCENE_VIEW_SETTINGS_ROUTE = '/product-configurators/:configuratorId/config/scenes/:sceneId/view-settings/:viewId';
export const PRODUCT_CONFIGURATOR_SCENE_VIEW_DETAILS_ROUTE = '/product-configurators/:configuratorId/config/scenes/:sceneId/views/:viewId';
export const PRODUCT_CONFIGURATOR_SCENE_LABELS_ROUTE = '/product-configurators/:configuratorId/config/scenes/:sceneId/options';
export const PRODUCT_CONFIGURATOR_SCENE_LABEL_DETAILS_ROUTE = '/product-configurators/:configuratorId/config/scenes/:sceneId/options/:labelId';
export const PRODUCT_CONFIGURATOR_LABEL_OPTION_EDIT_ROUTE = '/product-configurators/:configuratorId/config/scenes/:sceneId/options/:labelId/o/:optionId';
export const PRODUCT_CONFIGURATOR_LABEL_OPTION_BASE_MATERIAL_ROUTE = '/product-configurators/:configuratorId/config/scenes/:sceneId/options/:labelId/bm/:optionId';
export const PRODUCT_CONFIGURATOR_SCENE_LABEL_DETAILS_ADD_OPTION_ROUTE = '/product-configurators/:configuratorId/config/scenes/:sceneId/options/:labelId/add-option';
export const PRODUCT_CONFIGURATOR_SETTINGS_ROUTE = '/product-configurators/:configuratorId/settings';
export const PRODUCT_CONFIGURATOR_DISPLAY_SETTINGS_ROUTE = '/product-configurators/:configuratorId/settings/display-settings';
export const PRODUCT_CONFIGURATOR_WATERMARK_SETTINGS_ROUTE = '/product-configurators/:configuratorId/settings/watermark-settings';
export const PRODUCT_CONFIGURATOR_FONT_SETTINGS_ROUTE = '/product-configurators/:configuratorId/settings/font-settings';
export const PRODUCT_CONFIGURATOR_THEME_SETTINGS_ROUTE = '/product-configurators/:configuratorId/settings/theme-settings';
export const PRODUCT_CONFIGURATOR_SORT_SETTINGS_ROUTE = '/product-configurators/:configuratorId/settings/sort-settings';
export const PRODUCT_CONFIGURATOR_DOWNLOAD_SETTINGS_ROUTE = '/product-configurators/:configuratorId/settings/download-settings';
export const RENDERS_PREVIEWS_ROUTE = '/renders-previews';
export const RENDERS_PREVIEWS_ROUTE_V2 = '/my-files/images'
export const NEW_DESIGN_ROUTE = '/newdesigns/:id';
export const ROOMS_ROUTE = '/rooms';
export const TEMPLATES_ROUTE = '/templates';
export const TEMPLATES_ROUTE_V2 = '/library/templates';
export const TEMPLATES_DETAILS = '/templates/:id';
export const TEMPLATES_DETAILS_V2 = '/library/templates/:id';
export const TEMPLATES_DETAILS_ROUTE_PATH = '/templates/:roomId';
export const TEMPLATES_DETAILS_ROUTE_PATH_V2 = '/library/templates/:roomId';
export const PROPS_ROUTE = '/my-props';
export const PROPS_ROUTE_V2 = '/library/my-props';
export const SHARED_PRODUCT_PAGES_ROUTE_V2 = '/my-products/shared-product-page';
export const COLLECTIONS_ROUTE = '/collections';
export const COLLECTION_ID = '/collections/:id';
export const OLD_COLLECTION_ID = '/collection/:id';
export const COLLECTION_ID_ROUTE_PATH = '/collections/:collectionId';
export const OLD_COLLECTION_ID_ROUTE_PATH = '/collection/:collectionId';
export const COLLECTION_RENDER_ROUTE = '/collections/:collectionId/renders/:renderId';
export const COLLECTION_TEMPLATE_ROUTE = '/collections/:collectionId/templates/:roomId';
export const RENDER_DETAILS = '/renders-previews/:id';
export const RENDER_DETAILS_ROUTE_PATH = '/renders-previews/:renderId';
export const RENDER_DETAILS_V2 = '/my-files/images/:id';
export const RENDER_DETAILS_ROUTE_PATH_V2 = '/my-files/images/:renderId';
export const ROOM_RENDER = '/room-details';
export const NEW_PROJECTS_ROUTE = `${MY_PROJECTS_ROUTE}/createNew/:projectId`;
export const PROJECT_RENDER = `${MY_PROJECTS_ROUTE}/:projectId`;
export const PRODUCT_RENDER = '/products/my-rooms/preview/:id';

// exporting sidebar menu routes
export const MY_TEAM_ROUTE = '/teams';
export const SHARED_FILES_ROUTE = '/shared-files';
export const TAB = '/tab-ui';
export const SHARED_FILES_RENDER_ROUTE = '/shared-files/renders/:renderId';
export const SHARED_FILES_IMAGES_ROUTE = '/shared-files/images/:renderId';
export const SHARED_FILES_TEMPALTE_ROUTE = '/shared-files/templates/:roomId';
export const CALENDAR_ROUTE = '/calendar';
export const COMMUNITY_ROUTE = '/community';
export const SETTINGS_ROUTE = '/settings';
export const TRASH_ROUTE = '/trash';
export const PRICING_ROUTE = '/pricing'
export const MY_PLANS_ROUTE = '/my-plans'
export const TUTORIALS_ROUTE = '/tutorials';
export const PLAY_TO_LEARN_ROUTE = '/play-to-learn';
export const REQUESTS_ROUTE = '/requests';
export const REQUEST_DETAIL_ROUTE = '/requests/:id';
export const REQUEST_EDIT_ROUTE = '/requests/edit/:id';
export const REQUEST_EDIT_MAIN_ROUTE = '/requests/edit/';
export const NEW_REQUEST_ROUTE = '/requests/new/';
export const REQUESTS_ROUTE_MODELS = '/requests/models';
export const REQUESTS_ROUTE_PDP = '/requests/pdp';
export const REQUESTS_ROUTE_PDP_DETAIL = '/pdp-request-detail/:id';

export const SUPPORT_ROUTE = '/support';
export const PLANS_ROUTE = '/settings?activeTab=plans';

export const ADMIN_CURATOR = '/curator';
export const ADMIN_CURATOR_PROJECT_ID = '/curator/:type/:room_id';
export const ADMIN_CURATOR_ROOM_ID = '/curator/:type/:room_id';
// export const ADMIN_CURATOR_ROOM_ID_MODE = '/curator/:type/:room_id/:mode/:modeId'
export const ADMIN_MY_PROJECTS = '/projects';
export const ADMIN_MY_PROJECTS_V2 = '/my-files/projects'
export const ADMIN_LIST_MEMBERS = '/my-list-members';
export const ADMIN_NEW_PROJECT = '/projects';
export const ADMIN_MY_ROOMS = '/rooms';
export const ADMIN_MY_ROOMS_PARAMS = '/rooms/:id';
export const ADMIN_MY_PROPS = '/my-props';
export const ADMIN_MY_PRODUCTS_3DMODAL = '/products/my-models';
export const ADMIN_MY_PRODUCTS_3DMODAL_V2 = '/my-products/my-models';
export const ADMIN_MY_PRODUCTS_ROOMS = '/products/my-rooms';
export const ADMIN_MY_PRODUCTS_ROOMS_V2 = '/my-products/my-rooms';
export const ADMIN_MY_PRODUCTS_ROOMS_DETAILS = '/my-products/my-rooms/:id';
export const ADMIN_MY_PRODUCTS_TEXTURE = '/products/textures';
export const ADMIN_MY_PRODUCTS_TEXTURE_V2 = '/my-products/textures';
export const ADMIN_MY_PRODUCTS_TEXTURE_EDIT = '/products/textures/edit';
export const ADMIN_MY_PRODUCTS_TEXTURE_EDIT_V2 = '/products/textures/edit/v2';
export const ADMIN_MY_PRODUCTS_TEXTURE_UPLOAD = '/products/textures/upload';
export const ADMIN_MY_PRODUCTS_UPLOADS = '/products/custom-maps';
export const ADMIN_MY_PRODUCTS_UPLOADS_V2 = '/my-products/custom-maps';
export const ADMIN_MY_PRODUCTS_UPLOADS_MOVE_TO_TEXTURE = '/products/custom-maps/move-to-texture';
export const ADMIN_MY_PRODUCTS_3DMODAL_EACH = '/products/my-models/:id';
export const ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2 = '/products/my-models/v2/:id';
export const ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2 = '/products/textures/v2/:id';
export const ADMIN_MY_PRODUCTS_3DMODAL_EACH_PUBLIC = '/products/preview/:id';
export const ADMIN_MY_PRODUCTS_3DMODAL_EACH_PUBLIC_V2 = '/products/preview/v2/:id';
export const ADMIN_MY_TEXTURES_3DMODAL_EACH_PUBLIC_V2 = '/textures/preview/v2/:id';
export const ADMIN_MY_PRODUCTS_AIVIDEO_PREVIEW = '/products/video-preview/:id';
export const ADMIN_MY_PRODUCTS_AIVIDEO_RENDER = '/products/video-render/:id';

export const PRODUCT_360_VIEWER_PUBLIC = '/product/public/360-viewer/:id';
export const PRODUCT_360_VIEWER_PUBLIC_V2 = '/product/public/360-viewer/v2/:id';
export const TEXTURE_360_VIEWER_PUBLIC_V2 = '/texture/public/360-viewer/v2/:id';
export const PRODUCT_AI_VIDEO_PUBLIC = '/product/public/ai-video/:id';
export const PRODUCT_AI_VIDEO_PUBLIC_V2 = '/product/public/ai-video/v2/:id';
export const PRODUCT_AI_VIDEO_PUBLIC_TEXTURE_V2 = '/texture/public/ai-video/v2/:id';
export const PRODUCT_VIDEO_PUBLIC = '/product/public/video/:id';
export const PRODUCT_VIDEO_PUBLIC_V2 = '/product/public/video/v2/:id';
export const TEXTURE_VIDEO_PUBLIC = '/texture/public/video/v2/:id';
export const PRODUCT_PANNING_VIDEO_PUBLIC = '/product/public/panning-video/:id';
export const PRODUCT_AR_VIEWER_PUBLIC = '/product/public/ar-viewer/:id';
export const PRODUCT_AR_VIEWER_PUBLIC_V2 = '/product/public/ar-viewer/v2/:id';
export const PRODUCT_3D_VIEWER_PUBLIC_V2 = '/product/public/3d-viewer/v2/:id';
export const TEXTURE_3D_VIEWER_PUBLIC_V2 = '/texture/public/3d-viewer/v2/:id';

export const INSPIRATION_ROUTE = '/templates';
export const RECENT_DESIGNS_ROUTE = '/recent-designs';

export const NOTIFICATION_DETAILS_ROUTE = 'notifications/:notificationId';

//Detail routes
export const DETAIL_PAGE = '/detail-page';

export const INVITE_INTERNAL_USER = '/invite-internal-user';
export const INVITE_EXTERNAL_USER = '/invite-external-user';
export const MY_TEAM_TEXTURE = '/teams/texture';

export const PRODUCT_WEB_EXPERIENCE_PUBLIC = '/product-preview/web-experience/:id';

// automation
export const AUTOMATION_ROUTE = '/automation';
export const AUTOMATION_ROUTE_V2 = '/my-files/automation';
export const AUTOMATION_EXCEL_HISTORY = '/automation/:id/excel-list';
export const AUTOMATION_DETAILS = '/automation/:id';
export const CONFIGURATOR_VIEWER_ROUTE = '/configurator-viewer/:modelId';
export const CONFIGURATOR_PUBLIC_VIEWER_ROUTE = '/configurator-public-viewer/:modelId';
export const CONFIGURATOR_PUBLIC_VIEWER_ROUTE_V2 = '/configurator-public-viewer/v2/:modelId';
export const CONFIGURATOR_PUBLIC_VIEWER_ROUTE_TEXTURE_V2 = '/configurator-public-viewer/texture/v2/:modelId';
export const IMAGINE_AI_ROUTE_V2 = '/my-files/imagine-ai';


export const AI_ROUTE = '/ai';
export const AI_WEBSITE_URL = process.env.REACT_APP_AI_WEBSITE_URL
export const AI_WEBSITE_CREATION_TAB = `${process.env.REACT_APP_AI_WEBSITE_URL}creations`

export const WORKFLOW_BUILDER_ROUTE = '/workflow-builder';
export const WORKFLOW_BUILDER_URL = process.env.REACT_APP_WORKFLOW_BUILDER_URL;

export const MY_FILES_SHARED_FILES_RENDER_ROUTE = '/my-files/shared-files/renders/:renderId';
export const MY_FILES_SHARED_FILES_IMAGES_ROUTE = '/my-files/shared-files/images/:renderId';
export const MY_FILES_SHARED_FILES_TEMPALTE_ROUTE = '/my-files/shared-files/templates/:roomId';
export const MY_FILES_SHARED_FILES_ROUTE = '/my-files/shared-files';
export const RETAIL_ROUTE = '/retail/';
export const RETAIL_CONFIGURATOR_ROUTE = '/retail/configurator';
export const RETAIL_CONFIGURATOR_VIEWER_ROUTE = '/retail/configurator/viewer';
export const RETAIL_AUTOMATION_ROUTE_V2 = '/retail/automation';
export const RETAIL_AUTOMATION_ROUTE = '/my-files/retail-automation';
export const RETAIL_AUTOMATION_DETAILS_ROUTE = '/my-files/retail-automation/:automationId/*';
export const RETAIL_AUTOMATION_DETAILS_ROUTE_V2 = '/retail/automation/:automationId/*';
export const ADD_RETAIL_AUTOMATION_ROUTE = '/my-files/retail-automation/new';
export const ADD_RETAIL_AUTOMATION_ROUTE_V2 = '/retail/automation/new';
export const RETAIL_AUTOMATION_TAB_ROUTE = '/my-files/retail-automation/:automationId/:tabName';
export const RETAIL_AUTOMATION_TAB_ROUTE_V2 = '/retail/automation/:automationId/:tabName';
// guest user routes
export const SING_UP_GUEST_USER = '/guest-user';
export const SIGN_UP_GUEST_USER_WITH_TOKEN = '/guest-user-token';
export const PRODUCT_BUILDER_ROUTE = '/my-files/mattress-builder';
export const CURATOR_PRODUCT_BUILDER_ROUTE = '/curator/builder/:id';

export const MY_PRODUCTS = '/my-products/';
export const MY_FILES = '/my-files/';
export const ADMIN_MY_PRODUCTS_MATERIAL_V2 = '/my-products/materials';
export const PRODUCT_SETUP = '/product-setup/:id';
